
import Vue from 'vue';
    import { mapActions, mapGetters, mapMutations } from 'vuex';

declare const Alkami: any;

export default Vue.extend({
  name: 'location-search',
  data() {
    return {
      Alkami,
      streetAddress: '',
      city: '',
      state: '',
      zip: '',
      displayErrorBox: false,
      errMsg: '',
    };
  },
  methods: {
    ...mapMutations(['setHasSearched', 'setUsedMyLocation', 'setIsLoading']),
    ...mapActions(['getLatLngFromAddressAsync', 'getFullStateName']),
    clickUseMyLocation() {
      this.setUsedMyLocation(true);
      this.$router.replace({name: 'list'});
    },
    async submit() {
        this.setUsedMyLocation(false);

        const stateEmpty = (this.state === null || this.state === '');
        const cityEmpty = (this.city === null || this.city === '');

        const zipEmpty = (this.zip === null || this.zip === '');
        const zipRegexCheck = /^[0-9]{5}(?:-[0-9]{4})?$/.test(this.zip);
        const zipCodeErrMsg = "Zip code must only contain numbers and be five characters long. ";
        
        var errMsg = "";
        var inputHasErrors = false;

        // To search we need at least (zip code) or (city and state)

        if (!zipEmpty) {
            if (!zipRegexCheck) {
                inputHasErrors = true;
                errMsg += zipCodeErrMsg;
            }
        } else if (!stateEmpty || !cityEmpty) {
            if (stateEmpty) {
                inputHasErrors = true;
                errMsg += "Please enter state or zip code. ";
            }
            if (cityEmpty) {
                inputHasErrors = true;
                errMsg += "Please enter city or zip code. ";
            }
        } else {
            inputHasErrors = true;
            errMsg += "Please enter zip code or both city and state. ";
        }

        if (!inputHasErrors) {
            this.setIsLoading(true);
            let state = "";
            state = await this.getFullStateName(this.state);
            await this.getLatLngFromAddressAsync(this.streetAddress + ' ' + this.city + ' ' + state + ' ' + this.zip)
                .then(() => this.$router.replace({ name: 'list' }));
        } else {
            this.displayErrorBox = true;
            this.errMsg = errMsg;
        }
    }
  }
});
